export const table = [
  { title: 'Имя', id: 1 },
  { title: 'Телефон', id: 2 },
  { title: 'Почта', id: 3 },
  { title: 'Автосалон', id: 4 },
];
